<template>
<!--  :class="queryName"-->
  <div class="top-content flex-column" :style="{backgroundColor: navbarBackground}">
    <div class="flex-row flex-between tt-top">
      <img class="top-logo" src="@/assets/images/cma-top-logo.png">
      <div class="flex-row h100">
        <template v-for="item in navMenuList">
          <router-link class="flex-row align-center justify-center menu-item"
                       :class="[navMenu === item.path ? 'checked-item':'', isSolidBackground ? 'dark-back':'light-back']"
                       :to="item.path">
                        {{item.name}}
          </router-link>
        </template>
      </div>
      <el-dropdown v-if="token" trigger="click" placement="bottom" :append-to-body="false" @visible-change="removeImage" @command="handleCommand">
        <div v-if="token" class="flex-row align-center login-btu">
          <img class="head-img" :src="user.head_img">
          <div class="user-name">
            {{user.name}}
          </div>
          <img v-if="isOpen" class="arrow-icon" src="@/assets/images/up-arrow-icon.png">
          <img v-else class="arrow-icon" src="@/assets/images/down-arrow-icon.png">
        </div>
        <el-dropdown-menu class="dropdown-con" slot="dropdown" >
          <el-dropdown-item command="myInfo">
            <router-link class="dropdown-item" to="/myInfo">
              我的主页
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item command="password" divided>重置密码</el-dropdown-item>
          <el-dropdown-item command="logOut" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <router-link v-if="!token" class="flex-row align-center justify-center login-btu" to="/login">
        注册/登录
      </router-link>
    </div>
    <el-dialog class="user-dialog" :visible.sync="passDialog" :modal-append-to-body="false" width="480px" center @close="close">
      <div class="dialog-con">
        <div class="flex demo-input-suffix">
          <div class="x1">登录账号: </div>
          <div class="user-value">{{ sendData.type == 1 ? userData.mobile : userData.email }}</div>
        </div>
        <div class="flex demo-input-suffix">
          <div class="x1">验证码:</div>
          <el-input v-model="sendData.sms_code" autocomplete="new-sms_code" placeholder="请输入验证码" class="form-input">
            <template slot="append">
                <span
                  :class="['countdown-btn', { 'disabled': countdown > 0 }]"
                  @click="getVerificationCode">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                </span>
            </template>
          </el-input>
        </div>
        <div class="flex demo-input-suffix">
          <div class="x1">新密码:</div>
          <el-input class="half-line form-input" autocomplete="new-pass" v-model="sendData.pass" show-password type="password" placeholder="新密码">
          </el-input>
        </div>
        <div class="flex demo-input-suffix">
          <div class="x1">确认新密码:</div>
          <el-input class="half-line form-input" autocomplete="new-password" v-model="sendData.password" show-password type="password" placeholder="确认新密码">
          </el-input>
        </div>
        <div class="remark-con">
          注：密码重置后，Running派账号密码也将同步重置
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btu-con save-btu" :loading="btuLoading" @click="saveData">确认</el-button>
        <el-button class="btu-con cancel-btu" @click="passDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'top',
  props: {
    queryName: {
      type: String,
      default() {
      }
    }
  },
  data() {
    return {
      token: null,
      navMenuList: [
        {id: 1, name: '首页', path: '/index'},
        {id: 2, name: '赛事', path: '/game'},
        {id: 3, name: '选手', path: '/player'},
        {id: 4, name: '政策资讯', path: '/news'},
        // {id: 5, name: '积分说明', path: '/describe'},
      ],
      navMenu: '/index',
      isSolidBackground: false,
      heroHeight: 0,
      scrollPosition: 0,
      isOpen: false,
      passDialog: false,
      countdown: 0,
      btuLoading: false,
      userData: {
        mobile: '',
        email: ''
      },
      sendData: {
        sms_code: '',
        type: '',
        pass: '',
        password: '',
      },
      codeLoading: true,
      timer: null,
      isClick: true, //防止重复点击
    }
  },
  watch: {
    '$route': {
      handler(e) {
        this.navMenu = e.path
        this.handleScroll()
      },
      immediate: true
    },
  },
  computed: {
    navbarBackground() {
      if (this.isSolidBackground) {
        return '#2C2F35'; // 完全不透明黑色
      }
      return `rgba(44,47,53,0.6)`;
    },
    ...mapState({
      user: state => state.user,
    })

  },
  mounted() {
    window.addEventListener('scroll',this.handleScroll)// 监所英面滚动
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.timer)
  },
  created() {
    this.user.head_img = localStorage.getItem('headimg')
    this.user.name = localStorage.getItem('userName')
    this.userData = JSON.parse(localStorage.getItem('HRTP_USER')) || this.userData
    this.sendData.type = localStorage.getItem('loginType')
    this.token = localStorage.getItem('api_token') || null
    this.$store.state.sendData = {...this.sendData}
  },
  methods: {
    handleScroll() {
      // if (this.navMenu === '/index') {
      // 加上top本身的高度
        this.scrollPosition = window.scrollY + 100
        const heroElement = document.querySelector('.cover-con');
        if (heroElement) {
          // 当滚动超过大图高度时，切换为固定背景
          this.isSolidBackground = this.scrollPosition >= heroElement.offsetHeight;
        }
      // }
    },
    // 是否展示下拉
    removeImage(val) {
      this.isOpen = val
    },
    // 下拉操作
    handleCommand(command) {
      // if (command === 'myInfo') {
      //   this.$router.push({path: '/myInfo',})
      // }
      if (command === 'password') {
        this.passDialog = true
      }
      if (command === 'logOut') {
        localStorage.removeItem('userName')
        localStorage.removeItem('user_id')
        localStorage.removeItem('api_token')
        localStorage.removeItem('HRTP_USER')
        localStorage.removeItem('headimg')
        this.user.head_img = localStorage.getItem('headimg')
        this.user.name = localStorage.getItem('userName')
        this.userData = JSON.parse(localStorage.getItem('HRTP_USER')) || this.userData
        this.sendData.type = localStorage.getItem('loginType')
        this.token = localStorage.getItem('api_token') || null
        // this.$router.push({path: '/login',})
      }
    },
    // 跳转
    toRoute(e) {
      localStorage.clear();
      sessionStorage.clear()
      this.$router.push({path: e.path})
    },
    // 发送验证码
    getVerificationCode() {
      if(!this.isClick){
        return
      }
      this.isClick = false
      setTimeout(() => {
        this.isClick = true;
      }, 1000);
      if (this.countdown > 0) return;
      this.sendCode()
    },
    // 获取验证码
    sendCode() {
      if(this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      if(!this.codeLoading){
        return
      }
      this.codeLoading = false
      this.axios.get('/api/app/login-code', {
        params: {
          name: this.sendData.type == 1 ? this.userData.mobile : this.userData.email,
          way: this.sendData.type
        }
      }).then(res => {
        // 模拟发送验证码
        this.$message.success('验证码已发送');
        this.codeLoading = true;
        // 开始倒计时
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
          }
        }, 1000);
      }).catch(() => {
        this.codeLoading = true
      })
    },
    // 提交
    async saveData() {
      if(!this.sendData.sms_code) {
        this.$message.error("请输入验证码")
        return
      }
      if(!this.sendData.pass) {
        this.$message.error("请输入新密码")
        return
      }
      if(!/^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(this.sendData.pass)) {
        this.$message.error("密码长度必须至少为 8 个字符，至少包含一个字母、一个数字")
        return
      }
      if(!this.sendData.password) {
        this.$message.error("请确认密码")
        return
      }
      if (this.sendData.pass !== this.sendData.password) {
        this.$message.error("密码不一致，请重新输入")
        return
      }
      this.btuLoading = true
      let res = await this.$api.post('/api/app/sms-login', {
        name: this.sendData.type == 1 ? this.userData.mobile : this.userData.email,
        sms_code: this.sendData.sms_code,
        way: this.sendData.type
      })
      this.btuLoading = false
      if (res.msg.code == 0) {
        localStorage.setItem('api_token', res.data.api_token)
        let response = await this.axios.post('/api/app/user/info', {
          password: this.sendData.password
        })
        if (response.msg.code == 0) {
          this.$message.success('操作成功');
          this.passDialog = false
        }
      }
    },
    // 关闭弹窗
    close() {
      this.sendData = {...this.$store.state.sendData}
      this.countdown = 0
    }
  }
}
</script>

<style lang="less" scoped>
.top-logo{
  width: 145px;
}

.login-btu{
  width: 200px;
  height: 48px;
  background: #C3191A;
  color: #ffffff;
  border-radius: 26px;
  cursor: pointer;
  font-size: 18px;
}

.user-name{
  width: 94px;
  font-size: 18px;
  color: #FFFFFF;
  text-overflow: ellipsis;  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;   /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}

.head-img{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 14px 0 4px;
}
.arrow-icon{
  width: 16px;
  height: 16px;
  margin-left: 14px;
  margin-right: 8px;
}
.dropdown-con{
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.1);
  border-radius: 4px;

  /deep/ .el-dropdown-menu__item{
    font-size: 16px;
    color: #000000;
    width: 188px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

  }

  /deep/.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #FFFFFF;
    color: #C3191A;
  }
}

.dark-back:hover{
  background: rgba(44, 47, 53, 1);
}
.light-back:hover{
  background: rgba(44, 47, 53, 0.3);
}

.menu-item{
  width: 132px;
  height: 100%;
  position: relative;
  cursor: pointer;
  font-size: 18px;

  //&:hover{
  //  background: rgba(44, 47, 53, 0.3);
  //}
}

.menu-item::after {
  display: inline-block;
  content: "";
  width: 1px;
  height: 30px;
  background: rgba(255,255,255,0.3);
  position: absolute;
  right: 0;
  top: 35px;
}
.menu-item:last-child {
  &::after {
    display: none;
  }
}

.checked-item{
  background-color: #C3191A;
  position: relative;

  &:before{
    content: "";
    width: 100%;
    height: 2px;
    background: #ffffff;
    position: absolute;
    top: 98px;
  }

  &:hover{
    background: #C3191A;
  }
}

.dropdown-item{
  font-size: 16px;
  color: #000000;

  &:hover{
    color: #C3191A;
  }
}

.user-dialog{

  /deep/ .el-dialog__headerbtn{
    font-size: 24px;
  }
  /deep/.el-dialog__close{
    color: #585757;
  }
  /deep/ .el-dialog__headerbtn:hover .el-dialog__close {
    color: #C3191A;
  }

  .dialog-con{

    .demo-input-suffix {
      margin-right: 20px;
      margin-bottom: 24px;
      color: #666666;
      position: relative;
    }

    .x1 {
      margin-right: 5px;
      line-height: 40px;
      width: 110px;
      text-align: right;
      font-size: 20px;
      color: #666666;
    }

    .user-value{
      font-size: 20px;
      color: #666666;
      line-height: 40px;
    }

    .form-input{
      flex: 1;
      /deep/ .el-input__inner {
        padding: 0 0 0 24px;
        border: none;
        height: 40px;
        font-size: 20px;
        background: #F4F4F6;
        color: #333333;

        ::placeholder {
          color: #333333;
        }
      }


      /deep/ .el-input__prefix {
        display: none;
      }
      /deep/ .el-input-group__append{
        padding: 0 24px;
        //background-color: unset;
        color: #C3191A;
        border: none;
        border-radius: unset;
        cursor: pointer;
      }
      ///deep/ .el-input-group__append {
      //  width: 55px;
      //  background-color: #C3191A;
      //  border: none;
      //  border-radius: unset;
      //  padding: 0;
      //}
    }

    .half-line {
      width: 250px;
      height: 40px;
      //border-radius: 4px;
    }

    .user-talk{
      //flex: 1;
      width: calc(100% - 130px);
      //height: 130px;
      background: #F4F4F6;
      color: #333333;

      /deep/ .el-textarea__inner {
        height: 100%;
        padding: 8px 24px;
        border: none;
        font-size: 20px;
        background: #F4F4F6;
        color: #333333;
        resize: none;
      }
    }

    /deep/ .el-upload--picture-card{
      border: none;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item{
      width: 120px;
      height: 120px;
      border: none;
      border-radius: 50%;
    }

  }

  .btu-con{
    width: 160px;
    height: 46px;
    font-size: 22px;
    border-radius: 4px;
  }
  .save-btu{
    background: #C3191A;
    color: #FFFFFF;
    border: none;
  }
  .cancel-btu{
    border: 1px solid #C3191A;
    background: #FFFFFF;
    color: #C3191A;
  }
}

.remark-con{
  color: #666666;
}
@media screen and (min-width: 1100px) {
  .top-content {
    width: 100%;
    //min-width: 1280px;
    height: 100px;
    z-index: 1000;
    transition: background-color 0.3s ease;
    position: fixed;
    top: 0;
    left: 0;

    .tt-top {
      min-height: 100px;
      width: 1280px;
      color: #ffffff;
      position: relative;
      // overflow: hidden;  ////////////
      overflow: unset !important;
      align-items: center;
      margin: 0 auto;
    }
  }
}

@media screen and (max-width: 1100px) {

  .top-content {
    width: 100%;
    height: 100px;
    min-width: unset;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;

    .tt-top {
      position: relative;
      overflow: hidden;
      min-height: 100px;
      color: #ffffff;
      align-items: center;

    }

    .menu-item{
      width: 80px;
    }
  }
}

.h100{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue